// extracted by mini-css-extract-plugin
module.exports = {"admin-layout":"index__admin-layout___4ynSt","adminLayout":"index__admin-layout___4ynSt","logo":"index__logo___37XPA"};